import { styles } from '../../../renderers/node/nodeStyles';
import type { Relation } from '../../../types/relation';

export const getChildOffset = (
  amountOfOuts: number,
  position: number,
): number => {
  const spacing = styles.base.width / amountOfOuts;

  return spacing * position - spacing / 2;
};

export const getChildStartX = (
  preCalculatedStartX: Relation['pageX'],
): number => preCalculatedStartX;

export const getChildStartY = (
  preCalculatedStartY: Relation['pageY'],
): number => preCalculatedStartY;

export const getChildEndX = (preCalculatedEndX: Relation['pageX']): number =>
  /* End it in the center of child */
  preCalculatedEndX + styles.base.width / 2;

export const getChildEndY = (preCalculatedEndY: Relation['pageY']): number =>
  preCalculatedEndY;
